<template>
  <div
    :class="{
      'd-flex align-items-center': dot
    }"
  >
    <div
      :class="[
        bg,
        {
          border: withBorder,
          'balloon-container rounded-circle mr-2 w-unset': dot,
          'w-100 rounded-pill font-weight-bold': !dot
        }
      ]"
      :style="hexColor ? hexColorStyle : ''"
    >
      <div
        class="d-flex align-items-center"
        :class="{
          'justify-content-center': withBorder,
          'p-03': dot,
          'p-2': !dot
        }"
      >
        <em v-if="icon" class="fa-xs mr-2" :class="icon" />
        <span
          v-if="!dot"
          :style="'color:' + hexTextColor"
          :class="color"
          >{{ text }}</span
        >
      </div>
    </div>
    <span v-if="dot" class="font-weight-bold" :class="color">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "CustomBalloonLight",
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: () => null
    },
    bg: {
      type: String,
      default: () => ""
    },
    color: {
      type: String,
      default: () => ""
    },
    withBorder: {
      type: Boolean,
      default: () => true
    },
    dot: {
      type: Boolean,
      default: () => false
    },
    hexColor: {
      type: String,
      default: null
    },
    hexTextColor: {
      type: String,
      default: null
    }
  },
  computed: {
    hexColorStyle() {
      return {
        color: this.hexColor,
        backgroundColor: this.hexColor
      };
    }
  }
};
</script>

<style scoped>
.balloon-container {
  margin-left: 5px;
  margin-right: 5px;
  padding: 5px;
  text-align: center;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 900;
}
.green {
  color: #a4e5b2;
}
.brown {
  color: #d5b89a;
}
.yellow {
  color: #f8ea80;
}
.pink {
  color: #fcc9c8;
}
.violet {
  color: #ddb3d7;
}
.cream {
  color: #f8ca80;
}
</style>
